export const INDICATORS_DATA = {
  'Delayed advancement rate': {
    indicator: 'Delayed advancement rate',
    min: 0,
    max: 100
  },
  'Overall rating out of 10': {
    indicator: 'Overall rating out of 10',
    min: 0,
    max: 10
  },
  'Gr 4 avg score: Reading': {
    indicator: 'Gr 4 avg score: Reading',
    min: 0,
    max: 800
  },
  'Gr 4 avg score: Writing': {
    indicator: 'Gr 4 avg score: Writing',
    min: 0,
    max: 1000
  },
  'Gr 4 avg score: Literacy': {
    indicator: 'Gr 4 avg score: Literacy',
    min: 0,
    max: 900
  },
  'Gr 4 avg score: Numeracy': {
    indicator: 'Gr 4 avg score: Numeracy',
    min: 0,
    max: 800
  },
  'Gr 7 avg score: Reading': {
    indicator: 'Gr 7 avg score: Reading',
    min: 0,
    max: 800
  },
  'Gr 7 avg score: Writing': {
    indicator: 'Gr 7 avg score: Writing',
    min: 0,
    max: 1000
  },
  'Gr 7 avg score: Literacy': {
    indicator: 'Gr 7 avg score: Literacy',
    min: 0,
    max: 900
  },
  'Gr 7 avg score: Numeracy': {
    indicator: 'Gr 7 avg score: Numeracy',
    min: 0,
    max: 800
  },
  'Gr 7 gender gap: Reading': {
    indicator: 'Gr 7 gender gap: Reading',
    min: 0,
    max: 800
  },
  'Gr 7 gender gap: Literacy': {
    indicator: 'Gr 7 gender gap: Literacy',
    min: 0,
    max: 900
  },
  'Gr 7 gender gap: Numeracy': {
    indicator: 'Gr 7 gender gap: Numeracy',
    min: 0,
    max: 800
  },
  'Below expectations (%)': {
    indicator: 'Below expectations (%)',
    min: 0,
    max: 100
  },
  'Tests not written (%)': {
    indicator: 'Tests not written (%)',
    min: 0,
    max: 100
  },
  'Gr 3 avg test mark: Lang. Arts': {
    indicator: 'Gr 3 avg test mark: Lang. Arts',
    min: 0,
    max: 100
  },
  'Gr 3 avg test mark: Math': {
    indicator: 'Gr 3 avg test mark: Math',
    min: 0,
    max: 100
  },
  'Gr 6 avg test mark: Lang. Arts': {
    indicator: 'Gr 6 avg test mark: Lang. Arts',
    min: 0,
    max: 100
  },
  'Gr 6 avg test mark: Math': {
    indicator: 'Gr 6 avg test mark: Math',
    min: 0,
    max: 100
  },
  'Gr 6 avg test mark: Science': {
    indicator: 'Gr 6 avg test mark: Science',
    min: 0,
    max: 100
  },
  'Gr 6 avg test mark: Social Studies': {
    indicator: 'Gr 6 avg test mark: Social Studies',
    min: 0,
    max: 100
  },
  'Percentage of tests failed': {
    indicator: 'Percentage of tests failed',
    min: 0,
    max: 100
  },
  'Gr 3 avg. level: Reading': {
    indicator: 'Gr 3 avg. level: Reading',
    min: 0,
    max: 4
  },
  'Gr 3 avg. level: Writing': {
    indicator: 'Gr 3 avg. level: Writing',
    min: 0,
    max: 4
  },
  'Gr 3 avg. level: Math': {
    indicator: 'Gr 3 avg. level: Math',
    min: 0,
    max: 4
  },
  'Gr 6 avg. level: Reading': {
    indicator: 'Gr 6 avg. level: Reading',
    min: 0,
    max: 4
  },
  'Gr 6 avg. level: Writing': {
    indicator: 'Gr 6 avg. level: Writing',
    min: 0,
    max: 4
  },
  'Gr 6 avg. level: Math': {
    indicator: 'Gr 6 avg. level: Math',
    min: 0,
    max: 4
  },
  'Tests below standard (%)': {
    indicator: 'Tests below standard (%)',
    min: 0,
    max: 100
  },
  'Avg. level Gr 9 Math (Acad)': {
    indicator: 'Avg. level Gr 9 Math (Acad)',
    min: 0,
    max: 4
  },
  'Avg. level Gr 9 Math (Apld)': {
    indicator: 'Avg. level Gr 9 Math (Apld)',
    min: 0,
    max: 4
  },
  'OSSLT passed (%)-FTE': {
    indicator: 'OSSLT passed (%)-FTE',
    min: 0,
    max: 100
  },
  'OSSLT passed (%)-PE': {
    indicator: 'OSSLT passed (%)-PE',
    min: 0,
    max: 100
  },
  'Gr 9 tests not written (%)': {
    indicator: 'Gr 9 tests not written (%)',
    min: 0,
    max: 100
  },
  'Average exam mark': {
    indicator: 'Average exam mark',
    min: 0,
    max: 100
  },
  'Percentage of exams failed': {
    indicator: 'Percentage of exams failed',
    min: 0,
    max: 100
  },
  'Graduation rate': {
    indicator: 'Graduation rate',
    min: 0,
    max: 100
  },
  'Diploma completion rate': {
    indicator: 'Diploma completion rate',
    min: 0,
    max: 100
  },

  'Cote globale (sur 10)': {
    indicator: 'Cote globale (sur 10)',
    min: 0,
    max: 10
  },
  "Langue d'enseignement (%)": {
    indicator: "Langue d'enseignement (%)",
    min: 0,
    max: 100
  },
  'Langue seconde (%)': {
    indicator: 'Langue seconde (%)',
    min: 0,
    max: 100
  },
  'Histoire et éducation à la citoyenneté (%)': {
    indicator: 'Histoire et éducation à la citoyenneté (%)',
    min: 0,
    max: 100
  },
  'Science et technologie (%)': {
    indicator: 'Science et technologie (%)',
    min: 0,
    max: 100
  },
  'Mathématiques (%)': {
    indicator: 'Mathématiques (%)',
    min: 0,
    max: 100
  },
  'Échec (%)': {
    indicator: 'Échec (%)',
    min: 0,
    max: 100
  },
  "Surestimation par l'école (%)": {
    indicator: "Surestimation par l'école (%)",
    min: 0,
    max: 100
  },
  "Écart sexes (%): Langue d'ens.": {
    indicator: "Écart sexes (%): Langue d'ens.",
    min: 0,
    max: 100
  },
  'Progression - taux de retard (%)': {
    indicator: 'Progression - taux de retard (%)',
    min: 0,
    max: 100
  },
};
